import StatusScreen from '@/components/StatusScreen';
import TextLink from '@/components/TextLink';
import { CheckIcon } from '@/icons';
import { classes } from './utils';

export type ResetPasswordConfirmationProps = {
  onReturnToLogin: () => void;
};

export default function ResetPasswordConfirmation({
  onReturnToLogin,
}: ResetPasswordConfirmationProps) {
  return (
    <StatusScreen
      variant="success"
      icon={<CheckIcon size={38} strokeWidth={2} />}
      title="Password reset"
      message="Your password has been updated. You can now sign in with your new password.">
      <div className={classes.backWrapper}>
        <TextLink onClick={onReturnToLogin}>Back to login</TextLink>
      </div>
    </StatusScreen>
  );
}
